export default {
  header: 'Uveďte prosím niekoľko podrobností',
  placeholder: 'Pridať komentár...',
};
